import { render, staticRenderFns } from "./CardTextEditor.vue?vue&type=template&id=4c43c39c&scoped=true"
import script from "./CardTextEditor.vue?vue&type=script&lang=js"
export * from "./CardTextEditor.vue?vue&type=script&lang=js"
import style0 from "./CardTextEditor.vue?vue&type=style&index=0&id=4c43c39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c43c39c",
  null
  
)

export default component.exports